// leaveLiveStreams.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

import setActiveStreamId from '../action/setActiveStreamId.js';

import getOperationData from '../selector/getOperationData.js';

/**
 * Leave live stream
 * @kind action
 * @return {Promise} Action promise.
 */
const leaveLiveStreams = () => async (dispatch, getState) => {
  const currentStreamId = getOperationData(
    getState(),
    ['liveStream'],
    'activeStreamId'
  );
  dispatch({
    type: MERGE_OPERATION_DATA,
    payload: {
      selectPath: ['liveStream', 'autoPayment', currentStreamId],
      data: {
        isEnabled: false,
      },
    },
  });
  return dispatch(
    setActiveStreamId({
      activeStreamId: undefined,
    })
  );
};

export default leaveLiveStreams;
